import { memo, useContext } from 'react'
import { useIntl } from 'react-intl'
import { pushWithCruiseFilters } from 'actions/CruiseActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import noop from 'lib/function/noop'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import TextButton from 'LuxKit/Button/TextButton'
import Group from 'components/utils/Group'
import CruiseSearchInputs from './Inputs/CruiseSearchInputs'

interface Props {
  open: boolean
  onClose?: () => void
  searchPage?: string
  isCruiselineLandingPage?: boolean
}

function CruiseSearchFiltersDrawer({
  open,
  searchPage,
  isCruiselineLandingPage,
  onClose = noop,
}: Props) {
  const intl = useIntl()
  const globalSearch = useContext(GlobalSearchStateContext)
  const queryParams = useQueryParams()
  const dispatch = useAppDispatch()

  const onSubmit = () => {
    dispatch(pushWithCruiseFilters(searchPage ?? '/search/cruises', globalSearch, queryParams))
    onClose?.()
  }

  return <ModalBase
    isOpen={open}
    onClose={onClose}
    mode="drawer"
  >
    <ModalHeader
      title={intl.formatMessage({
        id: 'sx1jdtnxviP4waA8QU9X',
        defaultMessage: 'Filters',
        description: 'Modal title for cruise search filters drawer in the cruise section',
      })}
      onCloseButtonClick={onClose}
    />
    <ModalBody>
      <ModalContent>
        <Group direction="vertical" gap={8}>
          <CruiseSearchInputs drawerMode isCruiselineLandingPage={isCruiselineLandingPage} />
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter>
      <TextButton
        kind="primary"
        type="submit"
        size="large"
        onClick={onSubmit}
      >
        {intl.formatMessage({
          id: 'oQEqSvZBfVQ6aRRI-vaI',
          defaultMessage: 'Search',
          description: 'Search button text in cruise filters drawer in the cruise section',
        })}
      </TextButton>
    </ModalFooter>
  </ModalBase>
}

export default memo(CruiseSearchFiltersDrawer)
